import { Request } from "../../Servidor/Request";

export class ConstructionCategoryRequest {
    private sgepcategoriaconstrucao: number;
    private nome: string;

    constructor(sgepcategoriaconstrucao: number, nome: string) {
        this.sgepcategoriaconstrucao = sgepcategoriaconstrucao;
        this.nome = nome;
    }

    /**
     * Getter sgepcategoriaconstrucao
     * @return {number}
     */
    public getsgepcategoriaconstrucao(): number {
        return this.sgepcategoriaconstrucao;
    }

    /**
     * Getter nome
     * @return {string}
     */
    public getNome(): string {
        return this.nome;
    }
}

export class ConstructionCategoryStructRequest {
    private sgepcategoriaconstrucao: number;

    constructor(sgepcategoriaconstrucao: number) {
        this.sgepcategoriaconstrucao = sgepcategoriaconstrucao;
    }

    /**
     * Getter sgepcategoriaconstrucao
     * @return {number}
     */
    public getsgepcategoriaconstrucao(): number {
        return this.sgepcategoriaconstrucao;
    }
}

export class ConstructionCategoryInteractor {
    public fetchSave(request: ConstructionCategoryRequest): PromiseLike<Boolean> {
        return new Promise((res, rej) => {
            return new Request().requestPost("basico/categoria-construcao/salvar", request).then((rs) => {
                if (rs == undefined) {
                    return rej({
                        Mensagem: "Erro ao conectar!"
                    })
                }

                let response = rs.Status == "Sucesso!"
                res(response)
            }, e => {
                rej(e);
            });
        });
    }

    public fetchDataOne(request: ConstructionCategoryStructRequest): PromiseLike<ConstructionCategoryRequest> {
        return new Promise((res, rej) => {
            return new Request().requestPost("basico/categoria-construcao/buscar", request).then((rs) => {
                if (rs == undefined) {
                    return rej({
                        Mensagem: "Erro ao conectar!"
                    })
                }

                res(rs.Resultado)
            }, e => {
                rej(e);
            });
        });
    }
}
